<template>
  <div class="list">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" class="demo-inline-form" :model="search_sale">
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="comeTime"
            type="daterange"
            align="left"
            @change="dateChange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input style="width:160px;" v-model="search_sale.FMerchantId" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="商户简称">
          <el-input style="width:160px;" v-model="search_sale.FMerchantName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="直属代理商">
          <el-select
            style="width:150px;"
            v-model="search_sale.FAgentId"
            placeholder="直属代理商"
            clearable
            filterable
            :filter-method="handleAgentInfoFilter"
            :disabled="roleName == 'operator'"
          >
            <el-option
              v-for="item in agents_search_list"
              :key="item.fAgentId"
              :label="item.fAgentId"
              :value="item.fAgentId"
            >
              <span class="value">{{ item.fAgentId }}</span>
              <span class="name">{{ item.fTitle }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最近无交易天数">
          <el-input
            style="width:110px;"
            v-model.number="search_sale.minConsecutiveNoTradeDays"
            placeholder="请输入天数"
          ></el-input>-
          <el-input
            style="width:110px;"
            v-model.number="search_sale.maxConsecutiveNoTradeDays"
            placeholder="请输入天数"
          ></el-input>
          <span>仅限(3-90)的天数区间</span>
        </el-form-item>
        <el-form-item>
          <auth-button opt="search" icon="el-icon-search" @click.native="buttonSearch" label="查询"></auth-button>
          <auth-button
            opt="export"
            download="商户申请记录.csv'"
            icon="el-icon-download"
            @click.native="buttonExport"
            label="导出"
            :loading="exportLoading">
          </auth-button>
        </el-form-item>
        <el-row>
          <p class="calculate">
            <span class="weightFont">流失商户统计：</span>&nbsp;&nbsp;&nbsp;
            <span>
              连续3天无交易商户数：
              <span class="weightFont">{{ statisticData.count3 || '--' }}</span>&nbsp;&nbsp;&nbsp;
              4-7天无交易商户数：
              <span
                class="weightFont"
              >{{ statisticData.count4To7 || '--' }}</span>&nbsp;&nbsp;&nbsp;
              8-15天无交易商户数：
              <span
                class="weightFont"
              >{{ statisticData.count8To15 || '--' }}</span>&nbsp;&nbsp;&nbsp;
              16-30天无交易商户数：
              <span
                class="weightFont"
              >{{ statisticData.count16To30 || '--' }}</span>&nbsp;&nbsp;&nbsp;
              30天以上无交易商户数：
              <span
                class="weightFont"
              >{{ statisticData.count30AndMore || '--' }}</span>&nbsp;&nbsp;&nbsp;
            </span>
          </p>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="tableCard">
      <el-table
        border
        style="width:100%;float:left;margin-left:-5px;"
        align="center"
        v-loading="saleLoading"
        :data="sale_list"
        max-height="490">
        <el-table-column prop="fCreateTime" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="fMerchantId" label="商户编号" align="center"></el-table-column>
        <el-table-column prop="fMerchantName" label="商户简称" align="center"></el-table-column>
        <el-table-column prop="agentStr" label="直属代理商" align="center"></el-table-column>
        <el-table-column prop="lastTransTime" label="无交易开始日期" align="center"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" :context="_self">
          <template slot-scope="scope">
            <auth-button
              opt="details"
              icon="el-icon-search"
              size="mini"
              label="查看统计数据"
              @click.native="checkCalculate(scope.$index, scope.row)"></auth-button>
          </template>
        </el-table-column>
    </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <!--        统计数据弹窗-->
    <el-dialog :visible.sync="checkVisible" title="交易统计数据" width="600px">
      <p>说明：默认统计最近3个月内的商户交易数据；交易笔数及交易金额均不含退款订单；</p>
      <div class="statisticData">
        <el-row>
          <el-col :span="10" class="title">最低日交易笔数</el-col>
          <el-col :span="14" class="content">{{ sumData.minCount }}</el-col>
          <el-col :span="10" class="title">最低日交易金额</el-col>
          <el-col :span="14" class="content">¥{{ sumData.minAmountStr }}</el-col>
          <el-col :span="10" class="title">最高日交易笔数</el-col>
          <el-col :span="14" class="content">{{ sumData.maxCount }}</el-col>
          <el-col :span="10" class="title">最高日交易金额</el-col>
          <el-col :span="14" class="content">¥{{ sumData.maxAmountStr }}</el-col>
          <el-col :span="10" class="title">日平均交易笔数</el-col>
          <el-col :span="14" class="content">{{ sumData.sumCountStr }}</el-col>
          <el-col :span="10" class="title">日平均交易金额</el-col>
          <el-col :span="14" class="content">¥{{ sumData.sumAmountStr }}</el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { subAgentInfo, lostMerchantList, lostSumStatistic, exportLostMerchant, lostStatistic } from '@/api/merchant'
import qs from 'qs'
export default {
  name: 'Lost',
  data () {
    return {
      comeTime: [],
      search_sale: {
        FMerchantId: '',
        FMerchantName: '',
        FAgentId: '',
        minConsecutiveNoTradeDays: '3',
        maxConsecutiveNoTradeDays: '90',
        pageNo: 1,
        pageSize: 10,
        FStartTime: '',
        FEndTime: ''
      },
      // 日期快捷键
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      agents_search_list: [], // 代理商列表
      agents_search_list_back: [],
      saleLoading: false,
      checkLoading: false,
      exportLoading: false,
      sale_list: [],
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      salesNum: 0,
      roleName: '',
      statisticData: {
        count3: '',
        count4To7: '',
        count8To15: '',
        count16To30: '',
        count30AndMore: ''
      },
      checkVisible: false,
      sumData: {
        sumCountStr: '',
        maxAmountStr: '',
        sumAmountStr: '',
        minAmountStr: '',
        minCount: '',
        maxCount: ''
      }
    }
  },
  mounted () {
    this.getList()
    // this.getStatics();
    this.getUserInfo()
    if (this.roleName !== 'operator') {
      this.getAgentsList()
    }
  },
  methods: {
    getUserInfo () {
      this.roleName = this.$store.getters.userInfo.role.roleName
    },
    dateChange (value) {
      if (value !== null) {
        value[0] =
          value[0].getFullYear() +
          '-' +
          (value[0].getMonth() + 1 < 10
            ? '0' + (value[0].getMonth() + 1)
            : value[0].getMonth() + 1) +
          '-' +
          (value[0].getDate() < 10
            ? '0' + value[0].getDate()
            : value[0].getDate()) +
          ' 00:00:00'
        value[1] =
          value[1].getFullYear() +
          '-' +
          (value[1].getMonth() + 1 < 10
            ? '0' + (value[1].getMonth() + 1)
            : value[1].getMonth() + 1) +
          '-' +
          (value[1].getDate() < 10
            ? '0' + value[1].getDate()
            : value[1].getDate()) +
          ' 23:59:59'
        this.search_sale.FStartTime = value[0]
        this.search_sale.FEndTime = value[1]
      } else {
        this.search_sale.FStartTime = ''
        this.search_sale.FEndTime = ''
      }
    },
    /**
     * 获取代理商列表方法
     */
    getAgentsList () {
      // var data = this.formatSearch(this.agents_search_info);
      // data = qs.stringify(data);
      // 设一个超大的pageSize取所有数据
      subAgentInfo('pageSize=65535').then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
          const agentList = [
            {
              fAgentId: userInfo.fAgentId,
              fTitle: userInfo.fTitle
            }
          ]
          this.agents_search_list = agentList.concat(data.list)
          this.agents_search_list_back = [...this.agents_search_list]
        }
      })
    },
    /**
     * 直属代理商自定义筛选方法
     */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.agents_search_list = this.agents_search_list_back.filter(
          (item) => {
            return (
              item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) ||
              item.fTitle.toLowerCase().includes(queryString.toLowerCase())
            )
          }
        )
      } else {
        this.agents_search_list = this.agents_search_list_back
      }
    },
    // 点击搜索按钮事件
    onSearch () {
      this.checkLoading = true
      // this.search_sale.pageNo = 1;
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttonSearch () {
      var amountDays = this.validDays()
      if (!amountDays) {
        return
      }
      // 当点击查询时，显示第一页
      this.search_sale.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    validDays () {
      var num = /^[0-9]+$/
      var minDays = this.search_sale.minConsecutiveNoTradeDays
      var maxDays = this.search_sale.maxConsecutiveNoTradeDays
      if (
        (minDays !== '' && !num.test(minDays)) ||
        parseInt(minDays) < 3 ||
        parseInt(minDays) > 90
      ) {
        this.search_sale.minConsecutiveNoTradeDays = ''
        this.$message({
          showClose: true,
          message: '无交易天数必须为3-90的正整数',
          type: 'warning'
        })
        return false
      }
      if (
        (maxDays !== '' && !num.test(maxDays)) ||
        parseInt(maxDays) < 3 ||
        parseInt(maxDays) > 90
      ) {
        this.search_sale.maxConsecutiveNoTradeDays = ''
        this.$message({
          showClose: true,
          message: '无交易天数必须为3-90的正整数',
          type: 'warning'
        })
        return false
      }
      if (maxDays !== '' && minDays !== '') {
        if (parseInt(minDays) > parseInt(maxDays)) {
          this.search_sale.maxConsecutiveNoTradeDays = ''
          this.$message({
            showClose: true,
            message: '最近无交易天数最大值不能小于最近无交易天数最小值',
            type: 'warning'
          })
          return false
        }
      }
      if (maxDays === '' && minDays === '') {
        this.search_sale.minConsecutiveNoTradeDays = '3'
        this.search_sale.maxConsecutiveNoTradeDays = '90'
        this.$message({
          showClose: true,
          message: '最近无交易天数默认为3-90天',
          type: 'warning'
        })
        return false
      }
      if (maxDays === '' || minDays === '') {
        if (minDays === '') {
          this.search_sale.minConsecutiveNoTradeDays = '3'
        }
        if (maxDays === '') {
          this.search_sale.maxConsecutiveNoTradeDays = '90'
        }
        this.$message({
          showClose: true,
          message: '最近无交易天数最大值与最小值不能为空，默认为3-90天',
          type: 'warning'
        })
        return false
      }
      return true
    },
    // 获取流失商户列表
    getList () {
      this.saleLoading = true
      this.search_sale.FMerchantId =
        this.search_sale.FMerchantId &&
        this.search_sale.FMerchantId.replace(/ /g, '')
      this.search_sale.FMerchantName =
        this.search_sale.FMerchantName &&
        this.search_sale.FMerchantName.replace(/ /g, '')
      var data = this.formatSearch(this.search_sale)
      data = qs.stringify(data)
      lostMerchantList(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.saleLoading = false
        } else {
          this.saleLoading = false
          this.paginations.total = data.data.totalCount
          this.sale_list = data.data.list
          this.salesNum = data.data.totalCount
          this.statisticData = data.statistics
        }
      })
    },
    // 获取流失商户统计
    getStatics () {
      var data = {}
      data = qs.stringify(data)
      lostStatistic(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.statisticData = data.data
        }
      })
    },
    // 查看统计数据
    checkCalculate (index, row) {
      var data = {
        merchantId: row.fMerchantId
      }
      data = qs.stringify(data)
      lostSumStatistic(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.sumData = data.data
          this.checkVisible = true
        }
      })
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      var totalCount = this.salesNum
      // var pageSize = this.sale_list.length;
      this.search_sale.pageNo = page
      // this.search_sale.pageSize = pageSize;
      this.search_sale.Count = totalCount
      // this.search_sale.pageSize = size;
      this.getList()
    },
    buttonExport () {
      var amountDays = this.validDays()
      if (!amountDays) {
        return
      }
      // var startDate = new Date(this.comeTime[0]);
      // var endDate = new Date(this.comeTime[1]);
      if (!this.comeTime[0] || !this.comeTime[1]) {
        this.$message({
          message: '请筛选时间进行导出',
          type: 'warning'
        })
        return
      }
      // if(startDate.getMonth() == endDate.getMonth()){
      //     var yearNum=startDate.getFullYear();
      //     var monthNum = startDate.getMonth();
      //     monthNum = monthNum + 1
      //     var tmpDate = new Date(yearNum,monthNum,0);
      //     if((endDate.getTime()-startDate.getTime())/( 1000 * 3600 * 24) > tmpDate.getDate()){
      //         this.$message({
      //             showClose: true,
      //             message: "导出时间不能超过一个月，请检查后重试",
      //             type: 'warning'
      //         });
      //         return;
      //     }
      // }else{
      //     if((endDate.getTime()-startDate.getTime())/( 1000 * 3600 * 24) > 30){
      //         this.$message({
      //             showClose: true,
      //             message: "导出时间不能超过一个月，请检查后重试",
      //             type: 'warning'
      //         });
      //         return;
      //     }
      // }

      // 当点击查询时，显示第一页
      this.search_sale.pageNo = 1
      this.export()
    },
    export () {
      this.exportLoading = true
      this.exportList()
    },
    exportList () {
      var data = this.formatSearch(this.search_sale)
      data = qs.stringify(data)
      exportLostMerchant(data).then((response) => {
        this.exportLoading = false
        // 弹出下载框
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '商户信息.csv')
        document.body.appendChild(link)
        link.click()
      })
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    }
  }
}
</script>

<style scoped>
.demo-inline-form {
  margin-top: 18px;
}
.list {
  padding-left: 20px;
}
.calculate {
  font-size: 14px;
}
.calculate .weightFont {
  font-weight: bold;
}
.btm-action {
  margin-top: 20px;
  text-align: center;
}
.statisticData {
  margin: 0 auto;
  width: 500px;
  margin-top: 20px;
}
.statisticData .title {
  border-left: solid 1px #e8e8e8;
  border-top: solid 1px #e8e8e8;
}
.statisticData .title:nth-last-child(2),
.statisticData .content:last-child {
  border-bottom: solid 1px #e8e8e8;
}
.statisticData .content {
  border-left: solid 1px #e8e8e8;
  border-top: solid 1px #e8e8e8;
  border-right: solid 1px #e8e8e8;
}
.statisticData .title,
.statisticData .content {
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.statisticData .title {
  font-weight: bold;
  background: #fafafa;
}
</style>
